/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Info': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: '<path pid="0" d="M22 0c12.15 0 22 9.85 22 22s-9.85 22-22 22S0 34.15 0 22 9.85 0 22 0zm0 4C12.059 4 4 12.059 4 22s8.059 18 18 18 18-8.059 18-18S31.941 4 22 4zm2.007 13.997v8h1.999v4h-8v-4h2v-4h-2v-4h6.001zm-2.006-6a2 2 0 110 4 2 2 0 010-4z" _fill="#231F20" fill-rule="evenodd"/>'
  }
})
